// import bus from './bus.js'
import bus from 'core/services/Bus.js'
import ModalDialog from './ModalDialog.vue'

const modalGeneric = {
  install (Vue, options = {}) {
    /**
     * Open a modal with a component inside
     *
     * @param {object} component - Custom vue component
     * @param {object} componentProps - Props to custom vue component
     * @param {object} config - props to modal, like buttons, icon, title, etc.
     * @typedef {{title: string, icon: string, buttons: Array, modalProps: array}} config
     *
     * @example
     *
     *  this.$openModal(myComponent, { prop1: 3 }, {
          title: 'Im a title',
          icon: 'fa-trash',
          buttons: [
            {
              label: 'close',
              icon: 'fa-times',
              handler: () => {
                this.$closeModal()
              }
            },
            {
              label: 'submit',
              icon: 'fa-plane',
              classes: 'btn-primary',
              validate: true, => this button is only enable if doesn't have errors in $validator
              handler: (componentRef) => {
                alert('submit')
                this.$closeModal()
              }
            }
          ]
        })
     */
    Vue.prototype.$openModal = function (component, componentProps = {}, config = {}) {
      config.component = component
      config.componentProps = componentProps
      bus.$emit('modal.core:open', {
        component: 'modalTemplate',
        props: config
      })
    }

    /**
     * Open a modal dialog
     *
     * @param {object} config - props to modal, like buttons, icon, title, etc.
     * @typedef {{title: string, text: string, template: string, icon: string, buttons: Array, modalProps: array}} config
     *
     * @example
     *
     *  this.$openModalDialog({
          template: `
          <div>
              <i class="fas fa-badge-check fa-3x text-danger mb-2"></i>
              <br>
              <span class="text-info">Sample template/span>
          </div>
          `,
          text: 'text',
          title: 'My title',
          icon: 'fa-plane',
          buttons: [
            {
              label: 'close',
              icon: 'fa-times',
              handler: () => {
                this.$closeModal()
              }
            },
            {
              label: 'submit',
              icon: 'fa-plane',
              classes: 'btn-primary',
              handler: async () => {
                alert('test')
              }
            }
          ],
          modalProps: { allowedClose: false }
        })
     */
    Vue.prototype.$openModalDialog = function (config = {}) {
      if (!config.buttons) {
        config.buttons = [
          {
            label: 'close',
            icon: 'fa-times',
            handler: () => {
              this.$closeModal()
            }
          }
        ]
      }
      this.$openModal(ModalDialog, config, config)
    }

    /**
     * Close the current modal
    **/
    Vue.prototype.$closeModal = function () {
      bus.$emit('modal.core:close')
    }
  }
}

export default modalGeneric
